import React from 'react';
import { Page, Document, StyleSheet } from '@react-pdf/renderer';

import InvoiceHeaderLogo from './InvoiceHeaderLogo';
import InvoiceItemsTable from './InvoiceItemsTable';
import InvoiceFooter from './InvoiceFooter';
import InvoiceHeader from './InvoiceHeader';
import InvoiceBilledTo from './InvoiceBilledTo';
import InvoiceCustomFields from './InvoiceCustomFields';
import InvoicePaymentMethods from './InvoicePaymentMethods';
import DivisorLine from './DivisorLine';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 30,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 30,
    lineHeight: 1.5,
    flexDirection: 'column'
  }
});

const OrderSummaryPdf = ({
  invoice,
  retailerInfo,
  customer,
  phone,
  paymentMethods,
  paymentMethodsLabel
}) => {

  return (
    <Document>
    <Page size="A4" style={[styles.page, { paddingTop: retailerInfo.logo_url ? 20 : 30 }]}>
      {retailerInfo.logo_url && (<InvoiceHeaderLogo retailerInfo={retailerInfo} />)}
      <InvoiceHeader invoice={invoice} retailerInfo={retailerInfo} />
      <InvoiceBilledTo customer={customer} phone={phone} invoice={invoice} retailerInfo={retailerInfo} />
      {invoice.custom_answers && <InvoiceCustomFields customAnswers={invoice.custom_answers} />}
      { paymentMethods && paymentMethods.length > 0 && (
        <>
          <InvoicePaymentMethods paymentMethods={paymentMethods} labelText={paymentMethodsLabel} />
        </>
      )}
      <DivisorLine />
      <InvoiceItemsTable invoice={invoice} retailerInfo={retailerInfo} />
      <InvoiceFooter />
    </Page>
  </Document>
  );
};

export default OrderSummaryPdf;
